import { api } from 'api'
import { useQuery } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useFetchProvidersSettings = (isOpen: boolean) => {
  const response = useQuery({
    queryKey: ['useFetchProvidersSettings'],
    queryFn: api.providers.getMailingProviders,
    gcTime: 0,
    enabled: isOpen,
  })

  if (response.isError) {
    toaster.create({
      type: 'error',
      title: 'Произошла ошибка при загрузке конфигурации провайдеров',
      description: response.error?.message,
    })
  }

  return response
}
